import React from 'react';

// Empty component that renders nothing
const ArrowButton = () => null;

export default ArrowButton;
